<h1 mat-dialog-title>Ajout d'un appel d'offres</h1>
<div mat-dialog-content>
    <mat-form-field class="flexGrow1">
        <input matInput placeholder="Titre de l'appel d'offres" type="text" id="addNoticeTitle" [(ngModel)]="noticeTitle">
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button class="saveBtn" (click)="onSave()" cdkFocusInitial>Ajouter</button>
    <button mat-button class="cancelButton" (click)="onNoClick()">Annuler</button>
</div>